import { HelpOutlineOutlined, MinimizeOutlined } from "@mui/icons-material";

import { FORM_URL } from "../../App/constants";
import { useDispatch } from "react-redux";
import { DispatchProperties, useSelector } from "../../redux/store";
import { setOpenFeedback } from "../../redux/State/identitySlice/accountSlice";

const FeedbackButton = () => {
    const dispatch = useDispatch<DispatchProperties>();

    const open = useSelector(state => state.account.openFeedback);

    const openFormHandler = () => dispatch(setOpenFeedback(true))
    const closeFormHandler = () => dispatch(setOpenFeedback(false))

    return <div style={{
        position: 'fixed',
        bottom: 8,
        right: 16,
        ...(open && {
            minWidth: '300px',
            width: '100%',
            maxWidth: "450px",
            zIndex: 1000,
        }
        ),
    }}>
        {
            open ? (
                <>
                    <div
                        style={{
                            backgroundColor: 'white',
                            textAlign: 'end',
                            padding: "8px",
                        }}
                        onClick={closeFormHandler}
                    >
                        <MinimizeOutlined fontSize="small" />
                    </div>
                    <iframe src={FORM_URL}
                        title="Illuminate Support Ticket"
                        style={{
                            width: '100%',
                            border: 'none',
                            height: '600px',
                        }}
                    />
                </>
            ) : (
                <div
                    onClick={openFormHandler}
                    style={{
                        padding: '10px',
                        backgroundColor: '#EB9421',
                        borderRadius: '9px',
                        border: `1px solid rgba(0, 0, 0, 0.04)`,
                        color: 'white',
                        boxShadow: `0px 1px 2px 0px rgba(0, 0, 0, 0.04)`,
                        margin: '0 8px',
                        height: '40px',
                        width: '40px',
                    }}>
                    <HelpOutlineOutlined sx={{ height: '20px', width: '20px' }} />
                </div>)
        }
    </div>
}

export default FeedbackButton;